import { timeFormatAtom } from "../../recoil/timeFormat"; // Adjust the path if necessary
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import media from "../../static/style/media";
import { useRecoilValue, useRecoilState, useSetRecoilState } from "recoil";
import { userInfoAtom } from "../../recoil/user";
import { accessTokenAtom } from "../../recoil/auth";
import { useCookie } from "react-use";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { changeLangCustom } from "../../locales/langFunc";
import { FormControlLabel, Switch } from "@mui/material";
import { FaTimes, FaHome, FaBook, FaCompass, FaMobileAlt, FaUser, FaSignOutAlt, FaLanguage } from "react-icons/fa";
import lpgaLogo from "../../image/lpga_final_7_r.png";
// import lpgaLogo from "../../image/ngiilogo.png";

const navListItems = [
  { id: 0, name: "monitoring", route: "/", icon: <FaHome /> },
  { id: 1, name: "log", route: "/log", icon: <FaBook /> },
  { id: 2, name: "deviation", route: "/deviation", icon: <FaCompass /> },
  { id: 3, name: "device", route: "/device", icon: <FaMobileAlt /> },
  { id: 4, name: "user", route: "/user", icon: <FaUser /> },
];

export default function SideMenu() {
  const navigate = useNavigate();
  const userInfo = useRecoilValue(userInfoAtom);
  const setAccessToken = useSetRecoilState(accessTokenAtom);
  const [timeFormat, setTimeFormat] = useRecoilState(timeFormatAtom);
  const [, , removeCookie] = useCookie(["refreshToken"]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { t } = useTranslation();

  const onClickLogout = () => {
    setAccessToken(null);
    removeCookie("refreshToken");
    navigate("/login");
  };

  const changeLanguage = (lang, popupState) => {
    changeLangCustom(lang);
    popupState.close();
    window.location.reload();
  };

const filteredNavListItems =
  userInfo?.role === "ROOT"
    ? navListItems
    : userInfo?.role === "ADMIN"
    ? navListItems.filter((item) => item.id !== 4)
    : navListItems.filter((item) => item.id <= 2);


  const handleSwitchChange = () => {
    setTimeFormat((prev) => (prev === "locale" ? "utc" : "locale"));
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <Header>
      <LogoBox onClick={() => navigate("/")}>
        <LogoImg src={lpgaLogo} alt="LPGA Logo" />
      </LogoBox>
      <UserAndSettings>
        <NavSmallItems onClick={() => navigate("/profile")}>
          <Icon><FaUser /></Icon>
          {userInfo?.nickname}
        </NavSmallItems>
        <Separator />
        <NavSmallItems onClick={onClickLogout}>
          <Icon><FaSignOutAlt /></Icon>
          {t(`logout`)}
        </NavSmallItems>
        <Separator />
        <NavSmallItems>
          <PopupState variant="popover" popupId="language-popup-menu">
            {(popupState) => (
              <React.Fragment>
                <StyledButton variant="outlined" {...bindTrigger(popupState)}>
                  <Icon><FaLanguage /></Icon>{t(`language`)}
                </StyledButton>
                <Menu {...bindMenu(popupState)}>
                  <MenuItem onClick={() => changeLanguage("en", popupState)}>ENG</MenuItem>
                  <MenuItem onClick={() => changeLanguage("ko", popupState)}>KOR</MenuItem>
                  <MenuItem onClick={() => changeLanguage("ja", popupState)}>JPN</MenuItem>
                </Menu>
              </React.Fragment>
            )}
          </PopupState>
        </NavSmallItems>
        <Separator />
        <NavSmallItems>
          <FormControlLabel
            control={
              <StyledSwitch
                color="primary"
                checked={timeFormat === "utc"}
                onChange={handleSwitchChange}
              />
            }
            label={timeFormat?.toUpperCase()}
            labelPlacement="end"
          />
        </NavSmallItems>
        <Separator />
        <HamburgerMenu isOpen={isSidebarOpen} onClick={toggleSidebar}>
          <HamburgerIcon isOpen={isSidebarOpen} />
        </HamburgerMenu>
      </UserAndSettings>
      <SideDrawer isOpen={isSidebarOpen}>
        <CloseButton onClick={toggleSidebar} />
        <NavItemsContainer>
          {/* Menu All of Layouts */}  
          {filteredNavListItems.map((item, index) => (
            <React.Fragment key={item.id}>
              <NavItems
                isSelect={window.location.pathname === item.route}
                onClick={() => {
                  navigate(item.route);
                  setIsSidebarOpen(false);
                }}
              >
                {item.icon}
                <NavText>{t(`header.${item.name}`)}</NavText>
              </NavItems>
              {index < filteredNavListItems.length - 1 && <Divider />}
            </React.Fragment>
          ))}
          {/* {userInfo?.role === "ROOT" && (
            <React.Fragment>
              <NavItems onClick={() => navigate("/team")}>TEAM</NavItems>
              <Divider />
            </React.Fragment>
          )} */}
          <Divider />

          

          {/* User and Settings items moved here for tablet/mobile */}
          <UserSettingsContainer>
            <h5 style={{ padding: "0 10px", fontWeight: "900", fontSize: "20px" }}>User Info</h5>
            <Divider style={{ height: "3px" }} />
            <NavSmallItems onClick={() => navigate("/profile")}>
              <Icon><FaUser /></Icon>
              {userInfo?.nickname}
            </NavSmallItems>
            <Divider />
            <NavSmallItems onClick={onClickLogout}>
              <Icon><FaSignOutAlt /></Icon>
              {t(`logout`)}
            </NavSmallItems>
            <Divider />
            <NavSmallItems style={{ justifyContent: "space-between" }}>
              <PopupState variant="popover" popupId="language-popup-menu">
                {(popupState) => (
                  <React.Fragment>
                    <StyledButton variant="outlined" {...bindTrigger(popupState)}>
                      <Icon><FaLanguage /></Icon>{t(`language`)}
                    </StyledButton>
                    <Menu {...bindMenu(popupState)}>
                      <MenuItem onClick={() => changeLanguage("en", popupState)}>ENG</MenuItem>
                      <MenuItem onClick={() => changeLanguage("ko", popupState)}>KOR</MenuItem>
                      <MenuItem onClick={() => changeLanguage("ja", popupState)}>JPN</MenuItem>
                    </Menu>
                  </React.Fragment>
                )}
              </PopupState>
              <FormControlLabel
                control={
                  <StyledSwitch
                    color="primary"
                    checked={timeFormat === "utc"}
                    onChange={handleSwitchChange}
                  />
                }
                label={timeFormat?.toUpperCase()}
                labelPlacement="end"
              />
            </NavSmallItems>
            <Divider />
          </UserSettingsContainer>
        </NavItemsContainer>
      </SideDrawer>
    </Header>
  );
}

// 스타일 정의
const Header = styled.header`
  height: 80px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;

  ${media.small`
    height: 60px;
    padding: 0 10px;
  `}
`;

/* const LogoBox = styled.div`
  cursor: pointer;
`; */

/*
후보 폰트
font-family: 'Lato', sans-serif;
font-family: 'Poppins', sans-serif;
font-family: 'Raleway', sans-serif;
font-family: 'Roboto', sans-serif;
font-family: 'Source Sans Pro', sans-serif;
font-family: 'Work Sans', sans-serif;
font-family: 'IBM Plex Sans', sans-serif;
font-family: 'Open Sans', sans-serif;
font-family: 'Nunito', sans-serif; 
*/

const TitleContainer = styled.div`
  font-family: 'IBM Plex Sans', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  font-size: 1.8rem;
  font-weight: 900;
  color: #828282;
  letter-spacing: 0.06em;
  padding: 10px 15px;
  border-left: 1px solid #e0e0e0;
  
  h5 {
    margin: 0;
    font-size: 1.4rem;
    transition: color 0.3s ease;

    &:hover {
      color: #2980b9;
    }
  }

  ${media.small`
    display: none;
    font-size: 1.2rem;
    margin-left: 10px;
    h5 {
      font-size: 1rem;
    }
  `}
`;

const LogoBox = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  ${media.small`
    margin-left: 0;
  `}
`;


const HamburgerIcon = styled.div`
  position: relative;
  width: 30px;
  height: 3px;
  background-color: ${(props) => (props.isOpen ? "transparent" : "#333")};
  border-radius: 3px;
  transition: all 0.4s ease;
  &:before, &:after {
    content: "";
    position: absolute;
    width: 30px;
    height: 3px;
    background-color: #333;
    border-radius: 3px;
    transition: all 0.4s ease;
  }
  &:before {
    transform: ${(props) => (props.isOpen ? "rotate(45deg)" : "translateY(-10px)")};
  }
  &:after {
    transform: ${(props) => (props.isOpen ? "rotate(-45deg)" : "translateY(10px)")};
  }
`;

const LogoImg = styled.img`
  width: 300px;
  ${media.small`
    width: 220px;
  `}
  ${'' /* ${media.small`
    width: 330px;
  `} */}
`;

const UserAndSettings = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 1250px) {
    & > *:not(:last-child) {
      display: none; /* Hide all children except the last one */
    }
  }
`;

const NavItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;

  ${media.small`
    padding: 15px; /* Adjust padding for tablets/mobile */
  `}
`;

const NavItems = styled.div`
  font-weight: 500;
  font-size: 1.2rem;
  cursor: pointer;
  color: ${(props) => (props.isSelect ? "#007bff" : "#333")};
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  transition: background-color 0.3s ease, transform 0.2s ease;
  background-color: ${(props) => (props.isSelect ? "#f0f8ff" : "transparent")};

  &:hover {
    color: #007bff;
    background-color: #f4f8ff;
    transform: scale(1.02);
  }
`;

const NavText = styled.span`
  font-size: 1.1rem;
  font-weight: 600;
  margin-left: 10px;
  color: #333;
  transition: color 0.3s ease;
`;


const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e0e0e0;
  margin: 10px 0;
`;

const NavSmallItems = styled(NavItems)`
  font-size: 1rem;
`;

const HamburgerMenu = styled.div`
  font-size: 2.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  padding: 25px 15px; /* Increase padding for larger click area */
  border-radius: 50%; /* Optional: make the hit area circular */
  background-color: ${(props) => (props.isOpen ? "transparent" : "none")};
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.05); /* Optional: light background on hover */
  }

  &:active {
    background-color: rgba(0, 0, 0, 0.1); /* Optional: darker background on click */
  }

  ${media.small`
    display: flex;
  `}
`;


const SideDrawer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: ${(props) => (props.isOpen ? "300px" : "0")};
  height: 100%;
  background: linear-gradient(145deg, #ffffff, #f4f4f4); 
  box-shadow: ${(props) => (props.isOpen ? "0 8px 16px rgba(0, 0, 0, 0.2)" : "none")};
  overflow-x: hidden;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  padding-top: 60px;
  z-index: 1000;

  ${media.small`
    width: ${(props) => (props.isOpen ? "100vw" : "0")}; /* Adjust width for smaller screens */
  `}
`;

const CloseButton = styled(FaTimes)`
  font-size: 2rem;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  color: #333;
  transition: color 0.3s ease;
  &:hover {
    color: #ff4d4d;
  }
`;

const Separator = styled.span`
  display: inline-block;
  width: 1px;
  height: 20px;
  background-color: #ccc;
  margin: 0 20px;
`;

const Icon = styled.span`
  margin-right: 10px;
  font-size: 1.3rem;
  color: ${(props) => (props.isSelect ? "#007bff" : "#666")};
  transition: color 0.3s ease;
`;

const StyledButton = styled(Button)`
  border: 1px solid #007bff;
  color: #007bff;
  &:hover {
    background-color: #e7f0ff;
    border-color: #0056b3;
  }
`;

const StyledSwitch = styled(Switch)`
  .MuiSwitch-thumb {
    background-color: #007bff;
  }
  .MuiSwitch-track {
    background-color: #e0e0e0;
  }
`;

const UserSettingsContainer = styled.div`
  display: none; /* Default: Hide on larger screens */

  @media (max-width: 1250px) {
    margin-top: 80px;
    display: block; /* Show when screen width is 1250px or less */
  }
`;
